import React from 'react';
import { siteData } from '../mock';
import { Button } from './ui/button';

const OnlineSection = ({ onClick }) => {
  const { online, gallery } = siteData;
  return (
    <section className="bg-[#e5e5e3] text-[#1a1a1a] py-24 md:py-32 px-6 md:px-12">
      <div className="max-w-[1300px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center">
          <div>
            <h2
              className="text-[38px] md:text-[52px] lg:text-[58px] leading-[1.05] mb-8 max-w-[520px]"
              style={{ fontFamily: 'Fraunces, serif', fontWeight: 500 }}
            >
              {online.title}
            </h2>
            <p className="text-[18px] md:text-[20px] text-[#333] mb-10">
              {online.text}
            </p>
            <Button
              onClick={onClick}
              className="rounded-full bg-[#1c1c1c] hover:bg-[#2c2c2c] text-white px-10 py-7 h-auto text-[14px] font-medium"
            >
              {online.cta}
            </Button>
          </div>
          <div className="relative">
            <div className="w-full h-[380px] md:h-[420px] rounded-md shadow-xl overflow-hidden bg-black">
              <iframe
                title="ACT Online — Latest Stream"
                src={online.youtubeEmbedUrl}
                className="w-full h-full"
                style={{ border: 0 }}
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />
            </div>
            <p className="mt-3 text-xs text-[#555] text-center">
              Playing the latest ACT stream · when live, worship in real time.
            </p>
          </div>
        </div>

        {/* Gallery */}
        <div className="mt-24 md:mt-32 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {gallery.map((src, i) => (
            <div
              key={i}
              className="aspect-[3/4] overflow-hidden rounded-md group"
            >
              <img
                src={src}
                alt={`gallery-${i}`}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OnlineSection;
